var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3590_25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5599 13.9898C16.8099 13.3598 15.9699 12.8398 15.0599 12.4698C11.9799 11.1898 8.4599 11.1898 5.4099 12.4698C4.1299 13.0098 3.0299 13.7598 2.1299 14.7098C0.709901 16.2198 -0.0300993 18.1798 -9.92729e-05 20.3698C-9.92729e-05 20.7198 0.309901 21.1098 0.719901 21.1098H19.6899C20.1099 21.0398 20.3799 20.7298 20.3799 20.3298C20.3799 17.7498 19.4099 15.5598 17.5499 13.9998L17.5599 13.9898ZM1.5999 19.5598C1.8499 16.7398 3.7499 14.5598 6.8399 13.5798C9.1499 12.8498 11.6799 12.8898 13.9699 13.6998C15.0499 14.0798 16.0099 14.6498 16.7999 15.3698C17.9899 16.4898 18.6399 17.8598 18.8099 19.5498H1.5999V19.5598Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1998 10.22C13.0198 10.22 15.3098 7.93 15.3098 5.11C15.3098 2.29 13.0098 0 10.1998 0C7.38984 0 5.08984 2.29 5.08984 5.11C5.08984 7.93 7.37984 10.22 10.1998 10.22ZM6.63984 5.11C6.63984 3.15 8.23984 1.55 10.1998 1.55C12.1598 1.55 13.7598 3.15 13.7598 5.11C13.7598 7.07 12.1598 8.67 10.1998 8.67C8.23984 8.67 6.63984 7.07 6.63984 5.11Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3590_25"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.39,
    height: 21.11,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.60f87405034e0508f8e356e6ba817b3a.svg";
export { ForwardRef as ReactComponent };